import React from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect
} from "react-router-dom";
import YouTube from "./YouTube/YouTube";
import { Container, Segment } from "semantic-ui-react";
// import Home from "./Home";
// import Header from "./Header";
import UnityAssets from "./Assets";
import { Three } from "./Three";
import { YouTubeDownloader } from "./YouTubeDownloader";

const App = () => {
  return (
    <Router>
      <Segment inverted style={{ height: "100%" }}>
        <Container>
          {/*<Header />*/}
          <Switch>
            <Route path="/yt" component={YouTubeDownloader} />
            <Route path="/assets" component={UnityAssets} />
            <Route path="/youtube" component={YouTube} />
            <Route path="/three" component={Three} />
            {/*<Route path="/users">
              <div>users</div>
            </Route>
            <Route exact path="/">
              <Home />
            </Route>*/}
            <Redirect to="/assets" />
          </Switch>
        </Container>
      </Segment>
    </Router>
  );
};

export default App;
